/* eslint-disable @typescript-eslint/no-explicit-any */
// SetupFlow.js
import React from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import UpdateProfile from './onboarding/profileSetup/updateProfile';
import withBoxStyle from '../../HOC/layout/withBoxStyle';
import ProtectedRoute from '../../routes/ProtectedRoute';
import EnterPassword from './password/enterPassword';
import EnterOTPContainer from './otp';
import EnterEmail from './email';

import { useAppSelector } from '../../redux/hooks';

interface RouteConfig {
  path: string;
  element: React.ComponentType<any>;
  nextPath: string;
  protected?: boolean;
  firstTimeLoggedInUser?: boolean;
}

const routes: RouteConfig[] = [
  {
    path: '/email',
    element: EnterEmail,
    nextPath: '/otp',
  },
  {
    path: '/otp',
    element: EnterOTPContainer,
    nextPath: '/password',
  },
  {
    path: '/password',
    element: EnterPassword,
    nextPath: '/profile',
    protected: true,
  },
  {
    path: '/profile',
    element: UpdateProfile,
    nextPath: '/dashboard',
    protected: true,
    firstTimeLoggedInUser: true,
  },
];

const ChildRoutes = withBoxStyle(({ handleNextStep, isFirstTimeUser }: any) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Box sx={{ p: 3 }} className="d-flex flex-column flex-1">
      <Routes>
        {routes.map(
          ({
            path,
            element: Element,
            nextPath,
            protected: isProtected,
            firstTimeLoggedInUser,
          }) => {
            if (
              location?.pathname?.includes(path) &&
              !isFirstTimeUser &&
              firstTimeLoggedInUser
            ) {
              navigate('/dashboard');
              return null; // Skip rendering this route if it's not for first-time users only and the user is not a first-time user
            }
            return (
              <Route
                key={path}
                path={path}
                element={
                  isProtected ? (
                    <ProtectedRoute>
                      <Element
                        onNext={(options?: object) =>
                          handleNextStep(nextPath, options)
                        }
                      />
                    </ProtectedRoute>
                  ) : (
                    <Element
                      onNext={(options?: object) =>
                        handleNextStep(nextPath, options)
                      }
                    />
                  )
                }
              />
            );
          }
        )}
      </Routes>
    </Box>
  );
});

const Home = () => {
  const patientPlatformFirstLogin = useAppSelector(
    (state) => state.auth?.currentUser?.patientPlatformFirstLogin
  );
  const navigate = useNavigate();
  // Function to move to the next step
  const handleNextStep = (nextPath: any, options?: object) => {
    navigate(nextPath, options);
  };

  return (
    <ChildRoutes
      handleNextStep={handleNextStep}
      isFirstTimeUser={patientPlatformFirstLogin}
    />
  );
};

export default Home;
